/**
 * NetSuite CRM external case form helper (Patio Door Parts contact page).
 * Posts multipart forms to NetSuite without leaving the page (hidden iframe target).
 */
(function (global) {
  'use strict';

  var NS_ACTION =
    'https://4118934.extforms.netsuite.com/app/site/crm/externalcasepage.nl/compid.4118934/.f?formid=5&h=AAFdikaI57XHTed8CI_4A1pfYf4E2VF8YVm8WKrkqwwa1dx8pY0';
  var MIN_SUBMIT_MS = 3500;

  var EMAIL_RE =
    /^(?:[a-zA-Z0-9!#$%&*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&*+/=?^_{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

  function val(name, form) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? (field.value || '').trim() : '';
  }

  function normalizePhone(phone) {
    var digits = (phone || '').replace(/[\s.\-()+]/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.substring(1);
    return digits;
  }

  function validatePhoneUS(phone) {
    var digits = normalizePhone(phone);
    return digits.length === 10 && /^[2-9]\d{2}[2-9]\d{6}$/.test(digits);
  }

  function validateEmail(email) {
    return EMAIL_RE.test((email || '').trim());
  }

  function buildContactMessage(data) {
    var lines = ['WEBSITE CONTACT REQUEST', '=====================', ''];
    if (data.subject) lines.push('Topic: ' + data.subject);
    if (data.message) {
      lines.push('');
      lines.push('MESSAGE:');
      lines.push(data.message);
    }
    if (data.photos && data.photos.length) {
      lines.push('');
      lines.push('PHOTOS ATTACHED: ' + data.photos.length);
      data.photos.forEach(function (name, i) {
        lines.push((i + 1) + '. ' + name);
      });
    }
    lines.push('');
    lines.push('Submitted from: patiodoorparts.com contact page');
    return lines.join('\n');
  }

  function validateContact(form) {
    var first = val('firstname', form);
    var last = val('lastname', form);
    var email = val('email', form);
    var phone = val('phone', form);
    var subject = val('part_subject', form);
    var message = val('part_message', form);

    if (first.length < 2) return 'Please enter your first name (at least 2 characters).';
    if (last.length < 2) return 'Please enter your last name (at least 2 characters).';
    if (!validateEmail(email)) return 'Please enter a valid email address.';
    if (!validatePhoneUS(phone)) return 'Please enter a valid US phone number (e.g. 555-867-5309).';
    if (subject.length < 2) return 'Please select or enter a subject.';
    if (message.length < 10) return 'Please provide more details (at least 10 characters).';
    return null;
  }

  function showBanner(form, type, html) {
    var banner = form.querySelector('[data-ns-banner]');
    if (!banner) return;
    banner.hidden = false;
    banner.className = 'ns-case-banner ns-case-banner--' + type;
    banner.innerHTML = html;
    banner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideBanner(form) {
    var banner = form.querySelector('[data-ns-banner]');
    if (banner) banner.hidden = true;
  }

  function setSubmitting(form, submitting) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    btn.disabled = submitting;
    btn.classList.toggle('loading', submitting);
    if (submitting) {
      btn.dataset.origText = btn.textContent;
      btn.textContent = btn.dataset.loadingText || 'Submitting…';
    } else if (btn.dataset.origText) {
      btn.textContent = btn.dataset.origText;
    }
  }

  function goHome(form) {
    var url = (form && form.dataset.nsHomeUrl) || '/';
    window.location.assign(url);
  }

  function showSuccessDialog(form) {
    var id = form.dataset.nsSuccessDialog;
    var dialog = id ? document.getElementById(id) : null;

    if (!dialog || typeof dialog.showModal !== 'function') {
      showBanner(
        form,
        'success',
        '<strong>Message received!</strong> Our team will get back to you within one business day.'
      );
      return;
    }

    if (!dialog.dataset.nsBound) {
      dialog.dataset.nsBound = '1';
      var ok = dialog.querySelector('[data-contact-success-ok]');
      if (ok) {
        ok.addEventListener('click', function () {
          goHome(form);
        });
      }
      dialog.addEventListener('cancel', function (ev) {
        ev.preventDefault();
        goHome(form);
      });
      dialog.addEventListener('click', function (ev) {
        if (ev.target === dialog) goHome(form);
      });
    }

    dialog.showModal();
    var focusBtn = dialog.querySelector('[data-contact-success-ok]');
    if (focusBtn) focusBtn.focus();
  }

  var MAX_PHOTOS = 4;
  var MAX_PHOTO_BYTES = 8 * 1024 * 1024;
  var PHOTO_TYPES = {
    'image/jpeg': true,
    'image/png': true,
    'image/webp': true,
    'image/heic': true,
    'image/heif': true
  };

  function isPhotoFile(file) {
    if (!file) return false;
    if (PHOTO_TYPES[file.type]) return true;
    return /\.(jpe?g|png|webp|heic|heif)$/i.test(file.name || '');
  }

  function initPhotoPicker(form) {
    var input = form.querySelector('#ContactForm-photos');
    var slotsWrap = form.querySelector('[data-ns-photo-slots]');
    if (!input || !slotsWrap || input.dataset.nsPhotosBound) return;
    input.dataset.nsPhotosBound = '1';

    var files = [null, null, null, null];
    var urls = [null, null, null, null];
    var activeSlot = 0;

    function syncInput() {
      if (typeof DataTransfer === 'undefined') return;
      var dt = new DataTransfer();
      files.forEach(function (file) {
        if (file) dt.items.add(file);
      });
      input.files = dt.files;
    }

    function setSlot(idx, file) {
      if (urls[idx]) URL.revokeObjectURL(urls[idx]);
      urls[idx] = null;
      files[idx] = file || null;

      var btn = slotsWrap.querySelector('[data-ns-photo-slot="' + idx + '"]');
      var img = btn ? btn.querySelector('.contact-photo-slot__img') : null;
      var clear = slotsWrap.querySelector('[data-ns-photo-clear="' + idx + '"]');
      if (!btn || !img) return;

      if (file) {
        var url = URL.createObjectURL(file);
        urls[idx] = url;
        img.src = url;
        img.alt = file.name || ('Photo ' + (idx + 1));
        img.hidden = false;
        btn.classList.add('is-filled');
        btn.setAttribute('aria-label', 'Replace photo ' + (idx + 1));
        if (clear) clear.hidden = false;
      } else {
        img.removeAttribute('src');
        img.alt = '';
        img.hidden = true;
        btn.classList.remove('is-filled');
        btn.setAttribute('aria-label', 'Add photo ' + (idx + 1));
        if (clear) clear.hidden = true;
      }
      syncInput();
    }

    function clearAll() {
      files.forEach(function (_, idx) { setSlot(idx, null); });
    }

    slotsWrap.addEventListener('click', function (e) {
      var clear = e.target.closest('[data-ns-photo-clear]');
      if (clear) {
        e.preventDefault();
        setSlot(parseInt(clear.getAttribute('data-ns-photo-clear'), 10), null);
        return;
      }
      var slot = e.target.closest('[data-ns-photo-slot]');
      if (!slot) return;
      activeSlot = parseInt(slot.getAttribute('data-ns-photo-slot'), 10);
      input.value = '';
      input.click();
    });

    input.addEventListener('change', function () {
      var file = (input.files && input.files[0]) || null;
      if (!file) return;
      if (!isPhotoFile(file)) {
        showBanner(form, 'error', 'Please choose JPG or PNG photos.');
        return;
      }
      if (file.size > MAX_PHOTO_BYTES) {
        showBanner(form, 'error', 'Each photo must be 8 MB or smaller.');
        return;
      }
      setSlot(activeSlot, file);
    });

    form._nsClearPhotos = clearAll;
    form._nsPhotoNames = function () {
      return files.filter(Boolean).map(function (file) { return file.name || 'photo'; });
    };
  }

  function submitThroughIframe(form, onDone) {
    var targetName = form.getAttribute('target');
    var iframe = targetName ? document.querySelector('iframe[name="' + targetName + '"]') : null;
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      onDone();
    }
    if (iframe) {
      iframe.addEventListener('load', finish, { once: true });
    }
    HTMLFormElement.prototype.submit.call(form);
    setTimeout(finish, 2500);
  }

  function initForm(form) {
    if (!form || form.dataset.nsBound) return;
    form.dataset.nsBound = '1';

    var loadTime = Date.now();

    if (!form.getAttribute('action')) form.setAttribute('action', NS_ACTION);
    if (!form.getAttribute('method')) form.setAttribute('method', 'POST');
    if (!form.getAttribute('enctype')) form.setAttribute('enctype', 'multipart/form-data');

    initPhotoPicker(form);

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      hideBanner(form);

      var hp = form.querySelector('[name="pi_hp_url"]');
      if (hp && hp.value) return;

      if (Date.now() - loadTime < MIN_SUBMIT_MS) {
        showBanner(form, 'error', 'Please review your message before submitting.');
        return;
      }

      var err = validateContact(form);
      if (err) {
        showBanner(form, 'error', err);
        return;
      }

      var subject = val('part_subject', form);
      var message = val('part_message', form);
      var photos = form._nsPhotoNames ? form._nsPhotoNames() : [];
      var incomingField = form.querySelector('[name="incomingmessage"]');
      if (incomingField) {
        incomingField.value = buildContactMessage({
          subject: subject,
          message: message,
          photos: photos
        });
      }

      setSubmitting(form, true);

      submitThroughIframe(form, function () {
        setSubmitting(form, false);
        if (window.PDPAnalytics && typeof window.PDPAnalytics.track === 'function') {
          window.PDPAnalytics.track('contact_submit', {
            form_id: form.id || 'ContactForm',
            subject: subject || undefined,
            photo_count: photos.length || undefined
          });
        }
        form.reset();
        if (form._nsClearPhotos) form._nsClearPhotos();
        showSuccessDialog(form);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ns-case="contact"]').forEach(initForm);
  }

  global.NetSuiteCase = { initForm: initForm, buildContactMessage: buildContactMessage };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(window);
